<div class="c-wrapper">
    <div class="c-n-wrapper" id="cDesc">
        <span multilang class="c-title">{{datas?.CustomOffer?.Accommodation?.AccommodationName}}</span>
    </div>
    <ng-container *ngIf="datas?.extracomment?.length > 0">
        <div class="c-block">
            <div class="c-item">
                <span multilang class="c-item-title">Extra info</span>
                <div class="v-wrapper">
                    <pre class="ml pree">{{datas?.extracomment}}</pre>
                </div>
            </div>
        </div>
    </ng-container>
    <div class="c-block">
        <ng-container *ngFor="let cont of datas?.CustomOffer?.Accommodation?.ContentTexts?.ContentText">
            <div class="c-item">
                <span multilang *ngIf="cont.$?.Header?.length > 0" class="c-item-title">{{cont.$?.Header |
                    cleanText}}</span>
                <div multilang deeplMode='html' [innerHtml]="cont._ | cleanText | safehtml" class="c-content">
                </div>
            </div>
        </ng-container>
        <ng-container *ngIf="datas?.CustomOffer?.VideoUrls?.VideoUrl?.length > 0">
            <div class="c-item">
                <span multilang class="c-item-title" id="c-videos">Videos</span>
                <ng-container *ngFor="let vd of datas?.CustomOffer?.VideoUrls?.VideoUrl">
                    <iframe width="{{deskMode ? 500: '100%'}}" height="300" class="customIfram" [src]="vd?.Url | safe"
                        allowtransparency="true" allowfullscreen="true">
                    </iframe>
                </ng-container>
            </div>
        </ng-container>
    </div>

    <div class="f-btn-wrapper">
        <button class="f-btn" matRipple (click)="sendAnmeldung()">Jetzt buchen</button>
    </div>
</div>

<ng-container *ngIf="deskMode">
    <div class="c-nav-wrapper">
        <button class="c-nav-btn noselect" [class.cActive]="curentContent === 0" (click)="gotoDesc()"
            matRipple>Beschreibungen</button>
        <ng-container *ngIf="datas?.CustomOffer?.VideoUrls?.VideoUrl?.length > 0">
            <button class="c-nav-btn noselect" [class.cActive]="curentContent === 1" (click)="gotoVideos()"
                matRipple>Videos</button>
        </ng-container>
    </div>
</ng-container>

<div class="fixedlefttop">
    <button class="f-b-top" matRipple (click)="sendAnmeldung()">Jetzt buchen</button>
</div>